<template>
  <div>
    <myheader></myheader>
    <div class="goods">
      <van-swipe class="goods-swipe" :autoplay="3000">
        <van-swipe-item v-for="thumb in goods.thumb" :key="thumb">
          <img :src="thumb" >
        </van-swipe-item>
      </van-swipe>

      <van-cell-group>
        <van-cell>
          <div class="goods-title">{{ goods.title }}</div>
          <div class="goods-price">{{ formatPrice(goods.price) }}</div>
        </van-cell>
        <van-cell class="goods-express">
          <van-col span="10">运费：{{ goods.express }}</van-col>
          <van-col span="14">剩余：{{ goods.remain }}</van-col>
        </van-cell>
      </van-cell-group>

      <van-cell-group class="goods-cell-group">
        <van-cell title="查看商品详情" is-link @click="sorry" />
      </van-cell-group>

      <van-sku
        v-model="showSku"
        :sku="goods.sku"
        :goods="goods"
        :goods-id="goods.id"
        :hide-stock="true"
        :show-header-image="false"
        :message-config="messageConfig"
        @buy-clicked="onBuyClicked"
        @add-cart="onAddCartClicked"
      />
      <van-goods-action>
        <van-goods-action-icon icon="chat-o" @click="sorry">
          客服
        </van-goods-action-icon>
        <van-goods-action-icon icon="cart-o" @click="onClickCart">
          购物车
        </van-goods-action-icon>
        <van-goods-action-button type="warning" @click="onClickAddCart">
          加入购物车
        </van-goods-action-button>
        <van-goods-action-button type="danger" @click="sorry">
          立即购买
        </van-goods-action-button>
      </van-goods-action>
    </div>
  </div>
</template>

<script>

  import { Tag, Col, Icon, Cell, CellGroup, Swipe, Toast, SwipeItem, GoodsAction, GoodsActionIcon, GoodsActionButton, Sku } from 'vant'
  import { getInfo } from '@/api/product'
  import { Post as addToCart } from '@/api/cart'
  export default {
    components: {
      [Tag.name]: Tag,
      [Col.name]: Col,
      [Icon.name]: Icon,
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
      [Swipe.name]: Swipe,
      [SwipeItem.name]: SwipeItem,
      [GoodsAction.name]: GoodsAction,
      [GoodsActionIcon.name]: GoodsActionIcon,
      [GoodsActionButton.name]: GoodsActionButton,
      [Sku.name]: Sku
    },
    name: "info",
    data() {
      return {
        goods: {
          id: 1,
          title: '美国伽力果（约680g/3个）',
          price: 2680,
          express: '免运费',
          remain: 19,
          picture: 'https://img01.yzcdn.cn/2.jpg',
          thumb: [
            'https://img.yzcdn.cn/public_files/2017/10/24/e5a5a02309a41f9f5def56684808d9ae.jpeg',
            'https://img.yzcdn.cn/public_files/2017/10/24/1791ba14088f9c2be8c610d0a6cc0f93.jpeg',
          ],
          sku: {
            tree: [
              {
                k: '颜色', // skuKeyName：规格类目名称
                k_s: 'option1', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
                v: [
                  {
                    id: 'red', // skuValueId：规格值 id
                    name: '红色', // skuValueName：规格值名称
                    imgUrl: 'https://img01.yzcdn.cn/1.jpg', // 规格类目图片，只有第一个规格类目可以定义图片
                    previewImgUrl: 'https://img01.yzcdn.cn/1p.jpg', // 用于预览显示的规格类目图片
                  },
                  {
                    id: 'blue',
                    name: '蓝色',
                    imgUrl: 'https://img01.yzcdn.cn/2.jpg',
                    previewImgUrl: 'https://img01.yzcdn.cn/2p.jpg',
                  }
                ],
                largeImageMode: true, //  是否展示大图模式
              },
              {
                k: '尺寸', // skuKeyName：规格类目名称
                k_s: 'option2', // skuKeyStr：sku 组合列表（下方 list）中当前类目对应的 key 值，value 值会是从属于当前类目的一个规格值 id
                v: [
                  {
                    id: '55', // skuValueId：规格值 id
                    name: '5.5寸', // skuValueName：规格值名称
                  },
                  {
                    id: '7',
                    name: '7寸',
                  }
                ],
                largeImageMode: false, //  是否展示大图模式
              }
            ],
            // 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
            list: [
              {
                id: 2259, // skuId
                option1: 'red', // 规格类目 k_s 为 s1 的对应规格值 id
                option2: '7', // 规格类目 k_s 为 s2 的对应规格值 id
                price: 100, // 价格（单位分）
                stock_num: 110 // 当前 sku 组合对应的库存
              },
              {
                id: 2259, // skuId
                option1: 'blue', // 规格类目 k_s 为 s1 的对应规格值 id
                option2: '55', // 规格类目 k_s 为 s2 的对应规格值 id
                price: 10000, // 价格（单位分）
                stock_num: 110 // 当前 sku 组合对应的库存
              }
            ],
            price: '1.00', // 默认价格（单位元）
            stock_num: 227, // 商品总库存
            collection_id: 2261, // 无规格商品 skuId 取 collection_id，否则取所选 sku 组合对应的 id
            none_sku: false, // 是否无规格商品
            messages: [
              {
                // 商品留言
                datetime: '0', // 留言类型为 time 时，是否含日期。'1' 表示包含
                multiple: '0', // 留言类型为 text 时，是否多行文本。'1' 表示多行
                name: '留言', // 留言名称
                type: 'text', // 留言类型，可选: id_no（身份证）, text, tel, date, time, email
                required: '1', // 是否必填 '1' 表示必填
                placeholder: '' // 可选值，占位文本
              }
            ]
          },
        },
        showSku: false,
        messageConfig: {
          // 数据结构见下方文档
        }
      }
    },
    created() {
      this.goods.id = this.$route.params.id
      this.getInfo()
    },
    methods: {
      formatPrice() {
        return '¥' + (this.goods.price / 100).toFixed(2);
      },
      onClickCart() {
        this.$router.push('/carts');
      },
      onClickAddCart() {
        console.log(1234)
        this.showSku = true
      },
      onBuyClicked(sku) {
        console.log(sku)
      },
      onAddCartClicked(sku) {
        console.log(sku)
        console.log(sku.selectedSkuComb.id)
        const data = { sku_id: sku.selectedSkuComb.id, number: sku.selectedNum}
        addToCart(data).then(res => {
          Toast(res.message)
        })
      },
      sorry() {
        Toast('暂无后续逻辑~');
      },
      getInfo() {
        getInfo(this.goods.id).then(res => {
          this.goods = res.data
        })
      }
    }
  }
</script>

<style lang="less">
  .goods {
    padding-bottom: 50px;
    &-swipe {
      img {
        width: 100%;
        display: block;
      }
    }
    &-title {
      font-size: 16px;
    }
    &-price {
      color: #f44;
    }
    &-express {
      color: #999;
      font-size: 12px;
      padding: 5px 15px;
    }
    &-cell-group {
      margin: 15px 0;
      .van-cell__value {
        color: #999;
      }
    }
    &-tag {
      margin-left: 5px;
    }
  }
</style>
